
/* styles */
require("!!../../../../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-b415c90e&scoped=true!sass-loader?sourceMap!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./tag.vue")

var Component = require("!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./tag.js"),
  /* template */
  require("!!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-b415c90e!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./tag.vue"),
  /* scopeId */
  "data-v-b415c90e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/account/aggregate/modal/aggregate-register/tag.vue
// module id = 516
// module chunks = 1